import React from 'react';
import clsx from 'clsx';

export const MinusCircleOutlinedIcon = ({
  width,
  height,
  fill,
  className,
  ...rest
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='64 64 896 896'
      width={width}
      height={height}
      className={clsx('icon', 'icon-minus-circle-outlined', className)}
      {...rest}
    >
      <path
        fill={fill}
        d='M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
      />
      <path
        fill={fill}
        d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
      />
    </svg>
  );
};

MinusCircleOutlinedIcon.defaultProps = {
  width: 15,
  height: 15,
  fill: 'currentColor',
  className: ''
};
